module.exports = {
  "LayoutTokens" : {
    "space": {
        "1X": {
            "value": "4px"
        },
        "2X": {
            "value": "8px"
        },
        "3X": {
            "value": "12px"
        },
        "4X": {
            "value": "16px"
        },
        "5X": {
            "value": "20px"
        },
        "6X": {
            "value": "24px"
        },
        "8X": {
            "value": "32px"
        },
        "12X": {
            "value": "48px"
        },
        "16X": {
            "value": "64px"
        },
        "24X": {
            "value": "96px"
        },
        "32X": {
            "value": "128px"
        }
    }
}
    }


//////////////////
// WEBPACK FOOTER
// ./~/@vds-tokens/layout/dist/cjs/tokens.js
// module id = 11
// module chunks = 0